import { render, staticRenderFns } from "./WeChatPayPop.vue?vue&type=template&id=125400c1&scoped=true"
import script from "./WeChatPayPop.vue?vue&type=script&lang=js"
export * from "./WeChatPayPop.vue?vue&type=script&lang=js"
import style0 from "./WeChatPayPop.vue?vue&type=style&index=0&id=125400c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125400c1",
  null
  
)

export default component.exports